import { YesOrNoFlug } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = ["内容入力", "機構へ提出"];

const tableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050017_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    keyword: "lineTitleFacility",
    type: "lineTitle",
    lineTitle: "施設選択：",
  },
  {
    title: "施設名称",
    keyword: "facilityName",
    type: "selectForm",
    requiredIcon: true,
    helpicon: true,
    helpText: "対象となる施設を選択します。",
  },
  {
    keyword: "lineTitleInfo",
    type: "lineTitle",
    lineTitle: "基本情報：",
    showLine: true,
  },
  {
    title: "変更事項",
    keyword: "changes",
    type: "checkboxGroup",
    checkBoxList: [
      { label: "施設名称の変更" },
      { label: "施設の所在地の変更" },
      { label: "施設種類の変更" },
    ],
    setDefaultValue: [],
    requiredIcon: true,
    helpicon: true,
    helpText:
      "該当する変更事項を選択（複数選択可）してください。選択に応じた入力項目が表示されます。",
    showLine: true,
  },
  {
    title: "名称の変更年月日",
    keyword: "nameChangeDate",
    type: "date",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "名称を変更した日付を登録してください。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
    showLine: false,
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
  },
  {
    title: "旧：名称",
    keyword: "bFacilityName",
    type: "text",
    showLine: false,
  },
  {
    title: "新：名称",
    keyword: "aFacilityName",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        施設・事業所の正式な名称を入力してください。
        <br />
        ※指定通知、許認可書又は定款等で定められている名称を転記してください。
      </>
    ),
    showLine: false,
    inputProps: { maxLength: 85 },
  },
  {
    title: "所在地の変更年月日",
    keyword: "addressChangeDate",
    type: "date",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "所在地を変更した日付を登録してください。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
    showLine: false,
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
  },
  {
    title: "旧：郵便番号",
    keyword: "bZipcode",
    type: "text",
    showLine: false,
  },
  {
    title: "旧：所在地",
    keyword: "bAddress",
    type: "text",
    showLine: false,
  },
  {
    title: "新：郵便番号",
    keyword: "aZipcode",
    type: "addressSearch",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "郵便番号を入力後、「住所検索」ボタンを押していただくと、所在地が自動入力されます。",
    showLine: false,
  },
  {
    title: "新：所在地",
    keyword: "aAddress",
    type: "locationGroup",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "施設種類の変更年月日",
    keyword: "classChangeDate",
    type: "date",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "施設種類を変更した日付を登録してください。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
    showLine: false,
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
  },
  {
    title: "旧：施設種類",
    keyword: "bFacilityClassCd",
    type: "text",
    showLine: false,
  },
  {
    title: "新：施設種類",
    keyword: "aFacilityClassCd",
    type: "facilityType",
    isSCRC030001: false,
    requiredIcon: true,
    helpicon: true,
    helpText:
      "指定通知、許認可書又は定款等で定められている施設の種類を選択してください。",
    showLine: false,
  },
  {
    title: "転換する日以後の職員の加入有無",
    keyword: "transferedStaffJoinFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "当該施設種類の変更に伴い、施設区分が社会福祉施設等から特定介護保険施設等に変更となります。よって、施設の転換（変更）日以後に当該施設に新規加入する職員は単位掛金額の3倍の掛金が必要となります。以上を踏まえた上で、施設の転換（変更）日以後も職員を加入させる場合は「有」を、加入させない場合は「無」を選択してください。",
    showLine: false,
  },
  {
    title: "添付書類",
    keyword: "form",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "指定通知、許認可書等の変更後の施設種類が確認できる書類を添付してください。",
    showLine: false,
  },
];

const schema = {
  common: {
    facilityName: {
      required: TkPropertyMessageGet("TKMSG_SCR0044E"),
    },
    changes: {
      required: TkPropertyMessageGet("TKMSG_SCR0044E"),
    },
  },

  nameChange: {
    nameChangeDate: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    aFacilityName: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      pattern: {
        // eslint-disable-next-line no-control-regex
        value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
        message: TkPropertyMessageGet("TKMSG_SCR0061E"),
      },
      maxLength: {
        value: 85,
        message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
      },
    },
  },

  addressChange: {
    addressChangeDate: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    aZipcode: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      minLength: {
        value: 7,
        message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
      },
    },
    aAddress: {
      validate: (data: any) => {
        let error = {
          prefectures: "",
          city: "",
          address: "",
        };

        error = {
          prefectures: !data?.prefectures
            ? TkPropertyMessageGet("TKMSG_SCR0043E")
            : "",
          city: !data?.city
            ? TkPropertyMessageGet("TKMSG_SCR0043E")
            : data.city?.length > 20
            ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
            : // eslint-disable-next-line no-control-regex
            !data.city?.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/)
            ? TkPropertyMessageGet("TKMSG_SCR0061E")
            : "",
          address: !data?.address
            ? TkPropertyMessageGet("TKMSG_SCR0043E")
            : data.address?.length > 85
            ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
            : // eslint-disable-next-line no-control-regex
            !data.address?.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/)
            ? TkPropertyMessageGet("TKMSG_SCR0061E")
            : "",
        };

        if (
          error.prefectures !== "" ||
          error.city !== "" ||
          error.address !== ""
        ) {
          return JSON.stringify(error);
        }
      },
    },
  },

  classChange: {
    classChangeDate: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    aFacilityClassCd: {
      required: TkPropertyMessageGet("TKMSG_SCR0044E"),
    },
    form: {
      required: TkPropertyMessageGet("TKMSG_SCR0044E"),
    },
  },

  other: {
    transferedStaffJoinFlg: {
      required: TkPropertyMessageGet("TKMSG_SCR0044E"),
    },
  },
};

export { steps, tableList, schema };
